import React from 'react';
import Select from 'react-select';
import {
  ReactSelectHelper,
  ReactSelectOnChangeCallback
} from '../../../../../../lib/components/select/base/react-select-types';
import {McqBehavior, McqBehaviorLabels} from '../../models';

type BehaviorSelectProps = {
  value: McqBehavior;
  onChange: (behavior: McqBehavior) => void;
};

type OptionType = { value: McqBehavior, label: string };

const options: readonly OptionType[] = [
  {value: 'single-select', label: McqBehaviorLabels['single-select']},
  {value: 'multi-select', label: McqBehaviorLabels['multi-select']}
];

export class McqBehaviorSelector extends React.Component<BehaviorSelectProps> {
  constructor(props: Readonly<BehaviorSelectProps>) {
    super(props);
    this.handleChange = ReactSelectHelper.mappingSingle(
      'MatchingQuestionLeftType',
      (option: OptionType) => option.value,
      props.onChange);
  }

  handleChange: ReactSelectOnChangeCallback<OptionType>;

  render() {
    let value = options.find(x => x.value === this.props.value)!;
    if (value === undefined)
      value = options[0];

    return (
      <Select<OptionType> options={options}
                          value={value}
                          onChange={this.handleChange}
                          isClearable={false}>
      </Select>);
  }

}
